import { render, staticRenderFns } from "./HsabInsuranceClaim.vue?vue&type=template&id=6637643e&scoped=true"
import script from "./HsabInsuranceClaim.vue?vue&type=script&lang=ts"
export * from "./HsabInsuranceClaim.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6637643e",
  null
  
)

export default component.exports